import { useEffect } from "react";

// Carga el script oficial de Microsoft Clarity SI hay un Project ID
// definido en `import.meta.env.VITE_CLARITY_PROJECT_ID`. El loader es
// el snippet recomendado por Clarity adaptado para inyectarse sólo
// cuando el componente se monta (lo que en App.tsx pasa cuando el
// usuario ha consentido analítica → ver ConsentedAnalytics).
//
// El componente no renderiza nada visible.

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

export default function ClarityLoader() {
  useEffect(() => {
    const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
    if (!projectId) return;
    if (typeof window === "undefined") return;
    if (window.clarity) return; // already loaded

    // Snippet oficial Clarity v2 — la queue se llena hasta que el script
    // remoto carga, después el SDK la drena. Tipos `any` aquí son
    // inevitables: la firma global es genérica y la queue mutable.
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (function (c: any, l: Document, a: string, r: string, i: string) {
      c[a] = c[a] || function (...args: unknown[]) {
        (c[a].q = c[a].q || []).push(args);
      };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = "https://www.clarity.ms/tag/" + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode?.insertBefore(t, y);
    })(window as any, document, "clarity", "script", projectId);
    /* eslint-enable @typescript-eslint/no-explicit-any */

    // No hay teardown limpio: una vez cargado, Clarity vive hasta que el
    // usuario navega. Si más tarde retira el consentimiento, el gating
    // en trackEvent() evita que se le sigan enviando custom events; las
    // páginas que vea seguirán siendo grabadas hasta que recargue.
    // Limpio para v1; v2 puede invocar `clarity("stop")`.
  }, []);

  return null;
}
